<template>
  <div class="container">
    <div class="item" v-for="(item,index) in list" :key="index">
      <div class="productImg">
        <img :src="item.img" alt="M170 5G test multi-UE 多UE自动化测试"/>
      </div>
      <div class="productDescribe">
        <div class="title">{{item.title}}</div>
        <div class="describe">
          <!-- {{item.describe}} -->
          <div v-for="(item,index) in item.describe" :key="index" class="line">{{item.line}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      // list: [
      //   {
      //     img: "static/img/m170.jpg",
      //     title: "M170",
      //     describe: [
      //       { line: "多达16至32个USB3.0端口" },
      //       { line: "USB端口稳定供电能力>2A/端口" },
      //       { line: "内置高性能处理器" },
      //       { line: "单台数据吞吐量2Gbps" },
      //       { line: "多台M170可协同工作" },
      //       { line: "可选配大容量锂电池组，满足外场长时间OTA测试要求" }
      //     ]
      //   }
      // ]
      list:this.$store.state.language.f
    };
  },
  watch:{
    '$store.state.language.f'(val){
      console.log(val)
      this.list = val
    }
  }
};
</script>

<style scoped>
.container {
  box-sizing: border-box;
  border-top: 1px solid white;
}
.item {
  width: 70%;
  margin: 0 auto;
  margin-top: 30px;
  overflow: auto;
  padding-bottom: 1rem;
}
.productImg {
  width: 17rem;
  height: 17rem;
  float: left;
}
.productImg img {
  width: 100%;
  height: 100%;
}
.productDescribe {
  margin-left: 3rem;
  width: calc(100% - 20rem);
  min-height: 17rem;
  float: left;
}
.title {
  height: 4rem;
  line-height: 4rem;
  text-indent: 2rem;
  font-size: 1.5rem;
}
.describe {
  min-height: 10rem;
  line-height: 2rem;
  text-indent: 2rem;
  font-size: 1.2rem;
}
.line {
  width: 100%;
  min-height: 2rem;
  line-height: 2rem;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/product/M170.vue